module.exports = __webpack_public_path__ + "img/img_02.088869fb.png";